export const apiPath = {
  LOGIN: '/user/auth/token',
  LOGOUT: '/user/auth/logout',
  enterprise: '/admin/enterprise',
  admin: '/admin/get-users',
  count: '/admin/enterprise/counts',
  adminUser: '/admin/user-id',
  createAdmin: '/admin/add-user',
  GETFACILITY: '/admin/enterprise',
  notification: '/admin/notification',
  PUTFACILITY: '/admin/enterprise/facility',
  patients: '/provider/patient/all',
  GET_ADMIN_PROFILE: '/admin/profile',
  EDITUSER: '/admin/user',
  ROLE_PERMISSION: '/admin/roles-permissions',
  GET_ROLES: '/admin/roles',
  ADDUSER: '/admin/add-user',
  CHANGE_PASS: '/admin/change-password',
  ENTERPRISE_PASS: 'admin/enterprise',
  SET_PASSWORD: '/user/set-password',
  VERIFY_VERIFICATION_LINK: '/notification/email/verify-link',
  GENERATE_PASSWORD: '/admin/password',
  PLACES_OF_RESIDENCE: '/admin/place-of-residence',
  SELF_RESET_PASSWORD_ADMIN: '/admin/update-password-self',
  SELF_RESET_PASSWORD_PROVIDER: '/provider/update-password-self',
  GET_CONTRACT_COUNT: '/provider/contract/by-status/count',
  ENTERPRISE_LOGIN: '/user/auth/token/enterprise',
  THERAPIST_LOGIN: '/user/auth/token/therapist',
  GET_THERAPIST_PROFILE: '/provider/v2/profile',
  GET_PAY_COME_DETAILS: 'provider/paycom-status',
  SELF_RESET_PASSWORD_THERAPIST_ROLE: '/provider/update-password-self?role=THERAPIST',
  PATIENT: '/provider/patient',
  PHYSICIAN: '/provider/physician',
  ASSIGNED_FACILITIES: '/provider/facility/v2/assigned-facilities/all',
  SWITCH_FACILITY: '/provider/switch-facility/',
  GET_ALL_FACILITES_STAY: '/provider/patient/facility-stay',
  POST_RESET_PASSWORD_THERAPIST: 'provider/update-password-self?role=THERAPIST',
  PAYERPLAN: '/provider/payer-plan',
  GET_ALL_FACILITIES: '/provider/facility/all',
  DEPARTMENT_DASHBOARD: '/provider/department/dashboard/task-count',
  PATIENT_CSV_TEMPLATE: 'provider/import/patient',
  PATIENT_HISTORY: '/provider/patient-history',
  PATIENT_EXPORT_CSV: '/provider/export/patient',
  GET_ALL_PATIENT: '/provider/patient/active/true',
};

export const enterpriseApiPath = {
  PAYERPLAN: '/provider/payer-plan',
  CREATEPAYERPLAN: '/provider/payer-plan',
  facilities: '/provider/facility/all',
  facility: '/provider/facility',
  PHYSICIAN: '/provider/physician',
  RESET_PASSWORD: '/provider/update-password/enterprise-user',
};

export const BUILD_ENTERPRISE_USER_FORM = (enterpsieUuid: string) => {
  return `/api/admin/enterprise/${enterpsieUuid}/all`;
};

export const BUILD_DELETE_ENTERPRISE_USER = (enterpriseUuid: string, userUuid: string) => {
  return `/admin/enterprise/user/${enterpriseUuid}/${userUuid}`;
};

export const BUILD_EDIT_ENTERPRISE_USER = (enterpriseUuid: string, userUuid: string) => {
  return `/admin/enterprise/${enterpriseUuid}/update/${userUuid}`;
};

export const BUILD_EDIT_ENTERPRISE_USER_FOR_ENTERPRISE_ADMIN = (userUuid: string) => {
  return `/provider/${userUuid}`;
};

export const BUILD_ENTERPRISE_ACTIVATION = (id: string, status: boolean) => {
  return `/admin/enterprise/${id}/active/${status}`;
};

export const BUILD_ADMIN_USER_ACTIVATION = (id: string, status: boolean) => {
  return `/admin/user/${id}/active/${status}`;
};

export const BUILD_ENTERPRISE_USER_ACTIVATION = (id: string, parentId: string, status: boolean) => {
  return `/admin/enterprise/${parentId}/status/${id}?active=${status}`;
};

export const BUILD_FACILITY_ACTIVATION = (id: string, parentId: string, status: boolean) => {
  return `/admin/enterprise/${parentId}/facility/status/${id}?active=${status}`;
};
export const BUILD_FACILITY_ACTIVATION_ENTERPRISE = (id: string, status: boolean) => {
  return `/provider/facility/facility-uuid/${id}?active=${status}`;
};

export const enterpriseRoleAndPermissionApiPaths = {
  role: '/provider/roles-permissions',
  permissions: '/provider/roles-permissions/permissions',
  rolesConfiguration: '/provider/roles-permissions/all',
  updateroleProfuctivityPath: '/provider/roles-permissions/update-productivity',
};

export const BUILD_PAYER_PLAN_ACTIVATION = (id: string, status: boolean) => {
  return `/provider/payer-plan/${id}/status/${status}`;
};

export const BUILD_GET_PERMISSIONS_BY_ROLE = (id: string) => {
  return `/provider/roles-permissions/permissions-status/${id}`;
};

export const BUILD_UPDATE_PERMISSIONS_BY_ROLE_ID = (id: string) => {
  return `/provider/roles-permissions/update-permissions-status/${id}`;
};

export const BUILD_GET_ROLE_INFO_BY_ID = (id: string) => {
  return `/provider/roles-permissions/${id}`;
};

export const GET_ALL_THERAPIST_TASK = (id: string, isV2: boolean) => {
  if (isV2) return `/provider/v2/${id}/scheduling/all`;
  return `/provider/${id}/scheduling/all`;
};

export const GET_ALL_TASK_TYPE = (id: string) => {
  return `provider/${id}/scheduling/task-type`;
};

export const GET_ALL_THERAPIST = (id: string) => {
  return `provider/v2/${id}/scheduling/available-therapist/v3`;
};

export const GET_ALL_THERAPIST_DICIPLINE = (id: string, isV2: boolean) => {
  if (isV2) return `provider/v2/${id}/scheduling/discipline`;
  return `provider/${id}/scheduling/discipline`;
};

export const ASSIGN_THERAPIST_TASK = (id: string, therapistId: string) => {
  return `provider/${id}/scheduling/therapist/${therapistId}/verify`;
};

export const MIGRATE_THERAPIST_TASK = (id: string) => {
  return `provider/${id}/scheduling/migrate-task`;
};

export const MIGRATE_THERAPIST_PATIENT = (id: string) => {
  return `provider/${id}/scheduling/migrate-patient`;
};

export const UNDO_THERAPIST_ASSIGNMENT = (id: string, therapistId: string) => {
  return `provider/${id}/scheduling/therapist/${therapistId}/unassign`;
};

export const UNASSIGN_THERAPIST_PATIENT = (id: string, therapistId: string) => {
  return `provider/${id}/scheduling/therapist/${therapistId}/unassign/patient-tasks`;
};

export const REARRANGE_THERAPIST_TASK = (id: string) => {
  return `provider/${id}/scheduling/set-priority`;
};

export const EDIT_TASK_TIME = (id: string) => {
  return `provider/${id}/scheduling/update-time`;
};

export const THERAPIST_ASSIGN_DIALOG_TASK = (id: string, therapistId: string) => {
  return `provider/${id}/scheduling/therapist/${therapistId}/check-tasks`;
};

export const MyAvailability = {
  getMyAvailability: '/provider/availability',
  getAllPtoRequest: '/provider/availability/get-pto-requests',
  createPtoRequest: '/provider/availability/create-pto-request-v2',
  removePtoRequest: '/provider/availability/delete-pto-request',
  editAvailability: '/provider/availability',
  getTherapistList: '/provider/get-therapist-by-facility',
};

export const patientApiPaths = {
  getPatientsByFacilityId: '/provider/patient/all',
  createPatient: '/provider/patient',
  screeningDetails: '/screening-details',
  episodeOfCare: '/episode-of-care',
  episodeOfCareGetRequiredDocument: '/provider/document/scheduled-documents',
  getFormIdOfScreening: 'provider/patient',
  getMonthEndAlertCount: 'provider/month-end-alert',
  certifyMonthEnd: '/provider/month-end-alert/sign',
  getCertificationStatus: '/provider/month-end-alert/sign-get',
};

export const therapyPlanningPaths = {
  mdsAssessment: 'provider/mds-assessment',
  patientId: '/patient-uuid',
  planOfCare: 'provider/plan-of-care',
  therapyPlanning: 'provider/therapy-planning/',
  therapyPlanningV2: 'provider/v2/therapy-planning/',
  cptCodeByDiscipline: 'provider/authorization/cpt-codes/',
  editAuth: 'provider/authorization/v2',
  authDetails: 'provider/authorization/v2',
  multipleMDS: '/provider/mds-assessment/eoc',
  mdsValidate: '/provider/import/mds',
  saveTheTemplate: '/provider/therapy-planning-template',

  getAllTherapyPlanningTemplates: '/provider/therapy-planning-template',

  //therapy planing 2.0
  getTherapyPlaning_2_0: function (patientId: string) {
    return `/provider/v2/therapy-planning/${patientId}`;
  },

  getTherapyPlaningSummary: function (patientId: string) {
    return `/provider/v2/therapy-planning/summary/${patientId}`;
  },

  editSingleCell: function (patientId: string) {
    return `provider/v2/therapy-planning/single-cell/${patientId}`;
  },

  updateUncoveredDay: function (patientId: string) {
    return `/provider/v2/therapy-planning/uncovered/${patientId}`;
  },

  getDischarges: function (patientId: string) {
    return `/provider/v2/therapy-planning/discharge/${patientId}`;
  },

  copyTherapyWeek: function (patientId: string) {
    return `/provider/v2/therapy-planning/paste-week/${patientId}`;
  },

  applyTheTemplates: function (patientId: string) {
    return `/provider/v2/therapy-planning/template/apply/${patientId}`;
  },
  getMdsRange: function (patientId: string) {
    return `/provider/mds-assessment/assessment-detail/${patientId}`;
  },
  getSingleMds: function (mdsAssessmentId: string) {
    return `/provider/mds-assessment/assessment/${mdsAssessmentId}`;
  },

  deleteMdsByDate: function (patientId: string) {
    return `/provider/mds-assessment/delete-assessment/${patientId}`;
  },
  deleteSingleMds: function (mdsId: string) {
    return `/provider/mds-assessment/delete-assessment-mdsId/${mdsId}`;
  },

  get7DayLookBack: function (patientId: string) {
    return `/provider/v2/therapy-planning/sum/${patientId}`;
  },
};

export const documentLibrary = {
  getAllTemplates: '/provider/document/facility/get-all-templates',
  callSubmissionEvent: '/provider/document/facility/save-submission-data',
  getAllSubmittedDocuments: function (eocId: string) {
    return `/provider/document/facility/get-all-submission-data/episodeOfCare/${eocId}`;
  },
  getDataBySubmissionId: '/provider/document/form/submission',
  getSignatureTemplate: '/provider/document/create-sign',
  getAllMiscellaneousDocuments: '/provider/document/get-misc-documents',
  saveMiscellaneousDocument: '/provider/document/save-misc-document',
  getAllSupervisiors: '/provider/get-supervisor-by-discipline',
  editSignDocument: '/provider/document/edit-signed-document',
  sendMailToPhysician: '/provider/document/send-sign-to-physician',
  getCodes: function (patientUuid: string) {
    return `/provider/document/${patientUuid}/cpt-icd-codes`;
  },
  getSignatureAccess: '/provider/document/need-supervision',
  pullUuid: '/provider/document/get-unique-id',
  reAssignTherapist: function (documentUuid: string, providerId: string) {
    return `/provider/document/reassign/${documentUuid}/therapist/${providerId}`;
  },
  getAllProviderList: function () {
    return `/provider/facility/assigned-therapist/all`;
  },
  getPrefillUrl: function (uuid: string) {
    return `/provider/document/get-prefill-for-goals/${uuid}`;
  },
  startOfCare: '/provider/document/get-start-of-care-date/evaluation',
  deleteRequiredDocument: function (documentUuid: string) {
    return `/provider/document/delete-required-document/${documentUuid}`;
  },
  prepareProgressNote: function (episodeOfCareId: string) {
    return `/provider/document/call-prepare-data/${episodeOfCareId}`;
  },
  getSyncFromDocumentSignature: function (submission: string) {
    return `/notification/sync-signature/refresh/${submission}`;
  },
  checkDischargeDoc: function (eocId: string) {
    return `/provider/document/check-discharge/${eocId}`;
  },
  checkPendingDocs: function (eocId: string) {
    return `/provider/document/check-discharge-list/${eocId}`;
  },
};

export const subscribeSubmissionevent = '/notification/document/event/subscribe';

export const dailySessionNotes = {
  index: '/provider/daily-notes',
  all: '/provider/daily-notes/all',
  v2All: '/provider/v2/daily-notes/all',
  createNotes: '/provider/daily-notes/create-note-for-other-patient',
  otherPatient: '/provider/patient/other-patient/all',
  getTemplate: '/provider/daily-notes/get-template',
  editNote: '/provider/daily-notes/finalize-soap-note',
  submitEsign: '/provider/daily-notes/send-soap-note-signature',
  checkESign: 'provider/document/check-daily-note-sign',
};

export const therapist = {
  getAll: '/provider/all',
  getByRole: function (role: string) {
    return `/provider/get-by-roles/${role}`;
  },
  getTherapistTakNote: function (providerId: string, taskId: string) {
    return `/provider/${providerId}/scheduling/task-note/${taskId}`;
  },
  createTherapistTakNote: function (providerId: string, taskId: string) {
    return `/provider/${providerId}/scheduling/create-task/${taskId}`;
  },
};
export const dashboardApiCall = {
  patientList: '/provider/daily-notes/all',
  patientv2List: '/provider/v2/daily-notes/all',
  taskOverview: '/provider/dashboardOverview/others-status',
  documentationTask: '/provider/dashboardOverview/pending-documents',
  therapySession: '/provider/dashboardOverview/therapy-sessions',
  timeCheckIn: '/provider/dashboard/clock-in',
  timeCheckout: '/provider/dashboard/clock-in',
  dashboardDocuments: '/provider/dashboard/documents',
  patientDetails: '/provider/daily-notes',
  ptoUpdates: '/provider/availability/get-recent-pto',
  interventionGroup: '/provider/document/get-intervention-groups',
  gamesByIntervention: '/provider/document/get-intervention-games',
  autoClockOut: '/provider/dashboard/auto-clock',
  therapistDailyUpdates: '/provider/dashboard/notes',
};

export const laborHoursApiConstant = {
  getLaborHours: '/provider/labour-management/all',
  locationType: '/provider/labour-management/location-type',
  addLaborHrs: '/provider/labour-management',
  labourManagement: '/provider/labour-management',
  editLaborHours: '/provider/labour-management',
  deleteLabor: '/provider/labour-management',
};

export const mdsCommunication = {
  getMdsFormId: function (patientId: string) {
    return `/provider/mds-assessment/get-mds-form-id/${patientId}`;
  },
  getAllMds: function (patientId: string) {
    return `/provider/mds-assessment/get-mds-forms/${patientId}`;
  },
  signerToMds: function (mdsFormId: string) {
    return `/provider/mds-assessment/add-signer/${mdsFormId}`;
  },
  signMds: function (mdsFormId: string) {
    return `/provider/mds-assessment/create-sign/${mdsFormId}`;
  },
  getMdsById: function (mdsId: string) {
    return `/provider/mds-assessment/get-mds-form/${mdsId}`;
  },
  getMdsTypes: function (patientId: string) {
    return `/provider/mds-assessment/get-mds-date-type/${patientId}`;
  },
  getMdsReformId: function (parentId: string) {
    return `/provider/mds-assessment/get-mds-reform-id/${parentId}`;
  },
};

export const copyTextBank = {
  getCPTCodesDescription: '/provider/medical/description',
};

export const physician = {
  getAllDocumentsOfPhysician: function (physicianId: string) {
    return `/provider/physician/documents/${physicianId}`;
  },
  updatePhysicianDocumentStatuses: function (physicianId: string) {
    return `/provider/physician/documents/${physicianId}/update-statuses`;
  },
  facilities: '/provider/facility/all',
  getAllPatient: '/provider/patient/patient-by-enterprise/all',
};
